'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
var ApiDocs = function (_Component) {
  (0, _inherits3.default)(ApiDocs, _Component);

  function ApiDocs() {
    (0, _classCallCheck3.default)(this, ApiDocs);
    return (0, _possibleConstructorReturn3.default)(this, (ApiDocs.__proto__ || (0, _getPrototypeOf2.default)(ApiDocs)).apply(this, arguments));
  }

  (0, _createClass3.default)(ApiDocs, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'container' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'API Docs' }),
        _react2.default.createElement('div', { id: 'swagger-ui-container', className: 'swagger-ui-wrap' })
      );
    }
  }]);
  return ApiDocs;
}(_react.Component);

exports.default = ApiDocs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/ApiDocs/ApiDocs.js
// module id = 866
// module chunks = 0